import React from 'react';
import { useSelector } from 'react-redux';

import { Subscription } from 'Shared/constants/types';
import PlanInformation from './PlanInformation/PlanInformation';

type Props = {
  subscription?: Subscription;
  coupon?: {
    monthly: {
      percent_off: number;
      stripe_id: string;
    };
    annual: {
      percent_off: number;
      stripe_id: string;
    };
    custom: {
      percent_off: number;
      stripe_id: string;
    };
  };
};

function Plan({ subscription }: Props) {
  const billingState = useSelector(state => state.organization.billingState);
  const daysLeftInTrial = useSelector(state => state.organization?.daysLeftInTrial);

  return <PlanInformation subscription={subscription} billingState={billingState} daysLeftInTrial={daysLeftInTrial} />;
}

export default Plan;
